/**
 * Returns the user's local IANA timezone identifier (e.g. "America/New_York").
 * Falls back to the provided default when the browser can't determine one.
 */
export function getLocalTimeZone(fallback = 'UTC'): string {
  if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) return fallback;

  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || fallback;
  } catch {
    return fallback;
  }
}
